import React, { useState, useEffect, useRef } from 'react';
import { useRequest, history } from 'umi';
import styles from '../css/detailCSS.less';
import { Flex, Progress, Button, Tooltip } from 'antd';
import { Space, Swiper } from 'antd-mobile';
import { SwiperRef } from 'antd-mobile/es/components/swiper';
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import { getStudyNode } from '@/utils/requests/camp/requests_details';
import cx from 'classnames';
import { StudyInfoType } from '@/types/camp/study/studentBaseInfoType';
import { ProgressType, StudyNode } from '@/types/camp/details/detailsType';
import { NodeStudyState, CampStudyState } from '@/types/camp/study/index';

interface Props {
  studentBaseInfo: StudyInfoType | null;
  nodeProgress: ProgressType | null | undefined;
}

const CampStudy: React.FC<Props> = ({ studentBaseInfo, nodeProgress }) => {
  const [nodeData, setNodeData] = useState<StudyNode[]>([]);
  const [swiperLeftCur, setSwiperLeftCur] = useState<boolean>();
  const [swiperRightCur, setSwiperRightCur] = useState<boolean>();
  const ref = useRef<SwiperRef>(null);

  // 获取节点
  const { run: getStudyNodeRequest } = useRequest(
    (signUpId) => {
      return getStudyNode(signUpId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setNodeData(res);
      },
    },
  );

  const handlePercent = () => {
    if (nodeProgress) {
      return (nodeProgress.successNode / nodeProgress.allNode) * 100;
    } else {
      return 0;
    }
  };

  const handleNodePercent = (item: StudyNode) => {
    if (item.countAllQuestion > 0) {
      return (item.countSuccessQuestion / item.countAllQuestion) * 100;
    } else {
      return 0;
    }
  };

  // 监听轮播
  const swiperChange = (index: number) => {
    if (nodeData.length > 3) {
      if (index <= 1) {
        setSwiperLeftCur(false);
        setSwiperRightCur(true);
      } else if (index >= nodeData.length - 2) {
        setSwiperRightCur(false);
        setSwiperLeftCur(true);
      } else {
        setSwiperLeftCur(true);
        setSwiperRightCur(true);
      }
    }
    // console.log('index', index);
  };

  useEffect(() => {
    if (studentBaseInfo && studentBaseInfo.lastStudyNode) {
      swiperChange(studentBaseInfo?.startStudy ? studentBaseInfo.lastStudyNode.index : 1);
    } else {
      swiperChange(1);
    }
  }, [nodeData]);

  const btnText = (item: StudyNode) => {
    switch (item.studyState) {
      case NodeStudyState.NOT_START_LEARNING:
        return '开始学习';
      case NodeStudyState.STUDYING:
        const createdTime = new Date(item.createdTime);
        const lastModifiedTime = new Date(item.lastModifiedTime);
        const creatTamp = Math.floor(createdTime.getTime() / 1000);
        const lastTamp = Math.floor(lastModifiedTime.getTime() / 1000);

        if (creatTamp === lastTamp) {
          return '开始学习';
        } else {
          return '继续学习';
        }
      case NodeStudyState.NODE_SUCCESS:
        return '回看';
      case NodeStudyState.NODE_FAIL:
        return '查看';

      default:
        break;
    }
  };
  const isStudy = (item: StudyNode) => {
    const createdTime = new Date(item.createdTime);
    const lastModifiedTime = new Date(item.lastModifiedTime);
    return createdTime.getTime() !== lastModifiedTime.getTime();
  };

  useEffect(() => {
    if (studentBaseInfo) {
      getStudyNodeRequest(studentBaseInfo?.id);
    }
  }, [studentBaseInfo]);

  return (
    <div className={cx(styles.camp_study_box, 'com_cmap_card_box')}>
      <div className="flex_1 flex_3">
        <div className="f20 fw600">打卡学习</div>
        <div className="flex_1">
          <div className="colc0c">
            进度：{nodeProgress?.successNode}/{nodeProgress?.allNode}
          </div>
          <div style={{ width: 200, marginLeft: 10 }}>
            <Flex gap="small" vertical>
              <Progress percent={handlePercent()} showInfo={false} />
            </Flex>
          </div>
        </div>
      </div>

      {nodeData.length > 0 && (
        <div className={styles.swiper_box}>
          <Swiper
            indicator={() => null}
            ref={ref}
            trackOffset={33.3}
            slideSize={33.3}
            style={{ borderRadius: 8 }}
            defaultIndex={
              studentBaseInfo?.startStudy ? studentBaseInfo?.lastStudyNode?.index || 0 : 0
            }
            onIndexChange={(index) => swiperChange(index)}
          >
            {nodeData.map((item, index) => (
              <Swiper.Item key={index}>
                <div className={styles.swiper_item_box}>
                  <img
                    style={
                      studentBaseInfo?.campStudyState === CampStudyState.NOT_START_LEARNING ||
                      btnText(item) === '开始学习' ||
                      item.studyState === NodeStudyState.NODE_FAIL
                        ? { opacity: 0.5 }
                        : undefined
                    }
                    src={item.picture}
                    width={188}
                    height={140}
                    draggable="false"
                  />
                  <div className="f16 flex_4" style={{ marginTop: 6, gap: 6 }}>
                    <div className="flex_1" style={{ lineHeight: 1 }}>
                      <div className="hide_txt" style={{ maxWidth: 180, marginRight: 4 }}>
                        <Tooltip placement="top" title={item.name}>
                          {item.name}
                        </Tooltip>
                      </div>

                      <div style={{ marginTop: 3 }}>
                        {item.reviewState === 1 ? (
                          <span>
                            <ClockCircleOutlined className="f16 colffa" />
                          </span>
                        ) : item.studyState === 2 ? (
                          <span>
                            <CheckCircleOutlined className="f16 col52c" />
                          </span>
                        ) : item.studyState === 3 ? (
                          <span>
                            <CloseCircleOutlined className="f16 colff3" />
                          </span>
                        ) : (
                          item.studyState === 1 &&
                          item.countAllQuestion > 0 &&
                          isStudy(item) && (
                            <Progress type="circle" percent={handleNodePercent(item)} size={16} />
                          )
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="f14 col808 hide_txt" style={{ margin: '4px 0 12px', height: 22 }}>
                    <Tooltip placement="top" align={{ offset: [0, -4] }} title={item.description}>
                      <div style={{ maxWidth: 239 }}>{item.description}</div>
                    </Tooltip>
                  </div>
                  <div className="flex_4">
                    {studentBaseInfo?.campStudyState === CampStudyState.NOT_START_LEARNING ? (
                      <Button disabled>尚未解锁</Button>
                    ) : (
                      <a
                        className={
                          item.studyState === NodeStudyState.NODE_SUCCESS ||
                          item.studyState === NodeStudyState.NODE_FAIL
                            ? 'com_camp_btn_def'
                            : 'com_camp_btn'
                        }
                        style={{ width: 100, height: 32 }}
                        href={`/v2/camp/study/${item.signUpId}?nodeid=${item.id}`}
                      >
                        <span className="f14">
                          {item.reviewState === 1 ? '阅卷中' : btnText(item)}
                        </span>
                      </a>
                    )}
                  </div>
                </div>
              </Swiper.Item>
            ))}
          </Swiper>

          {swiperLeftCur && (
            <div
              className={cx(styles.swiper_btn_lf, 'flex_5')}
              onClick={() => {
                ref.current?.swipePrev();
              }}
            >
              <ArrowLeftOutlined />
            </div>
          )}
          {swiperRightCur && (
            <div
              className={cx(styles.swiper_btn_rt, 'flex_5')}
              onClick={() => {
                ref.current?.swipeNext();
              }}
            >
              <ArrowRightOutlined />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default CampStudy;
